import { useEffect, useState } from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { getLoginToken , authenticate, AuthorizationAPI, LoginState, ErrorState } from '../Recoil-State';
import { RouteProvider } from './Routes/RouteProvider';
import { BaseURL } from '../environment';
import { Loader } from '../core';
import { externalUserServices } from '../services';

export const AuthProvider = () => {
    const [ loading, setLoading ] = useRecoilState(LoginState);
    const [ error ] = useRecoilState(ErrorState);
    const [ auth, setAuth ] = useRecoilState(authenticate);
    const [isRouteValidForUser , setIsRouteValidForUser] = useState(true)
    const isToken = useRecoilValue(getLoginToken);
    const fxhubanalyticsRedirect = "/fxhubanalytics";
    // set Auth Token on Recoil State
    useEffect(()=> {
        if( isToken ) {
            setAuth(isToken);
        }

        setLoading(true);
        // eslint-disable-next-line
    }, [isToken]);

  // useEffect(() => {
  //   const checkExternalUser = async () => {
  //     const isRedirectRoutePresent = window.location.href.includes(fxhubanalyticsRedirect);
  //     const resData = await externalUserServices.isExternalUser(isToken?.email);
  //     if ((resData?.success === false || (Array.isArray(resData) && resData.length)) && isToken?.email && !isRedirectRoutePresent) {
  //       const appName = window?.name;
  //       window.location.href = appName ? `${BaseURL}${fxhubanalyticsRedirect}/${appName}` : `${BaseURL}${fxhubanalyticsRedirect}`;
  //     } else {
  //       setIsRouteValidForUser(true);
  //     }
  //   };
  //   checkExternalUser();
  // }, []);

    useEffect(() => {
      // call auth API 
      if( auth) {
        AuthorizationAPI(auth);
      }
    }, [auth]);
    
    
    return (
    <>
        { loading && <Loader size ={40} type= 'full' text ={ error || 'Loading'} className ={error ? 'text-red-500' :''}/>}
        { (!loading ) && isRouteValidForUser && (<RouteProvider/>)}
     </>
    )
}